module.exports = require('prop-types');